export default {
bind(el, {value}) {
	M.Tooltip.init(el, {html: value})
},
//тултип остается при переходе по страницам, нужн исп метод анбаинд
unbind(el) {
	const tooltip = M.Tooltip.getInstance(el)
	if (tooltip && tooltip.destroy){
		tooltip.destroy()
	} 
}
}
//функция баинд будет вызвана когда тултип будет проходить этам своей
//инициализации el это дом элемент куда добавл данную дерективу
//value значение котор будем передавать в нашу дерективу